import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { EstimateDataLite, EstimateFieldsNeedToRefresh } from "@Helpers/types/estimation/takeoffTypes";
import type { EstimateListItem } from "@ServerTypes/estimates/estimates.schema.js";

export type EstimateDataState = EstimateDataLite & {
  project?: { _id?: string };
  space?: { _id?: string };
  costDatabaseArray?: Array<{
    currency?: EstimateDataLite["costDatabase"] extends { currency?: infer C } ? C : unknown;
  }>;
};

export const estimateFieldsNeedToRefreshIntialState: EstimateFieldsNeedToRefresh = {
  takeoffs: [],
  measurements: false,
};

const estimateListSlice = createSlice({
  name: "estimateList",
  initialState: [] as EstimateListItem[],
  reducers: {
    getEstimateList: (_state, action: PayloadAction<EstimateListItem[]>) => action.payload,
    emptyEstimateList: () => [],
  },
});

const isEstimateExistSlice = createSlice({
  name: "isEstimateExist",
  initialState: true,
  reducers: {
    setIsEstimateExist: (_state, action: PayloadAction<boolean>) => action.payload,
  },
});

const estimateAdditionalCostSlice = createSlice({
  name: "estimateAdditionalCost",
  initialState: [] as Array<Record<string, unknown>>,
  reducers: {
    setAdditionalCost: (_state, action: PayloadAction<Array<Record<string, unknown>>>) => action.payload,
  },
});

const additionalCostTotalSlice = createSlice({
  name: "additionalCostTotal",
  initialState: 0,
  reducers: {
    setEstimateAdditionalCostTotal: (_state, action: PayloadAction<number>) => action.payload,
  },
});

const dateVersionSlice = createSlice({
  name: "dateVersion",
  initialState: [] as Array<Record<string, unknown>>,
  reducers: {
    getEstimateDateversion: (_state, action: PayloadAction<Array<Record<string, unknown>>>) => action.payload,
  },
});

const estimateDataSlice = createSlice({
  name: "estimateData",
  initialState: {} as EstimateDataState,
  reducers: {
    setEstimateData: (_state, action: PayloadAction<EstimateDataState>) => action.payload,
  },
});

const estimateFieldsNeedToRefreshSlice = createSlice({
  name: "estimateFieldsNeedToRefresh",
  initialState: estimateFieldsNeedToRefreshIntialState,
  reducers: {
    setEstimateFieldsNeedtoRefresh: (_state, action: PayloadAction<EstimateFieldsNeedToRefresh>) => action.payload,
  },
});

export const { getEstimateList, emptyEstimateList } = estimateListSlice.actions;
export const { setAdditionalCost } = estimateAdditionalCostSlice.actions;
export const { setEstimateAdditionalCostTotal } = additionalCostTotalSlice.actions;
export const { getEstimateDateversion } = dateVersionSlice.actions;
export const { setEstimateData } = estimateDataSlice.actions;
export const { setEstimateFieldsNeedtoRefresh } = estimateFieldsNeedToRefreshSlice.actions;
export const { setIsEstimateExist } = isEstimateExistSlice.actions;

export const estimateList = estimateListSlice.reducer;
export const getEstimateAdditionalCost = estimateAdditionalCostSlice.reducer;
export const additionalCostTotal = additionalCostTotalSlice.reducer;
export const getDateVersion = dateVersionSlice.reducer;
export const estimateData = estimateDataSlice.reducer;
export const estimateFieldsNeedToRefresh = estimateFieldsNeedToRefreshSlice.reducer;
export const isEstimateExistReducer = isEstimateExistSlice.reducer;

export default {
  estimateList,
  getEstimateAdditionalCost,
  additionalCostTotal,
  getDateVersion,
  estimateData,
  estimateFieldsNeedToRefresh,
  isEstimateExistReducer,
};
